import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HotelleriePage = lazy(() => import('../pages/secteurs/hotellerie/page'));
const BeautePage = lazy(() => import('../pages/secteurs/beaute/page'));
const EvenementielPage = lazy(() => import('../pages/secteurs/evenementiel/page'));
const RestaurationPage = lazy(() => import('../pages/secteurs/restauration/page'));
const ERPPage = lazy(() => import('../pages/solutions/erp/page'));
const CRMPage = lazy(() => import('../pages/solutions/crm/page'));
const RecrutementPage = lazy(() => import('../pages/recrutement/page'));
const EcosystemPage = lazy(() => import('../pages/ecosystem/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrestataireServicePage = lazy(() => import('../pages/secteurs/prestataire-service/page'));
const BtpConstructionPage = lazy(() => import('../pages/secteurs/btp-construction/page'));
const RhPlacementPage = lazy(() => import('../pages/secteurs/rh-placement/page'));
const CabinetsConseilPage = lazy(() => import('../pages/secteurs/cabinets-conseil/page'));
const VideoSurveillancePage = lazy(() => import('../pages/secteurs/video-surveillance/page'));
const AtelierGaragePage = lazy(() => import('../pages/secteurs/atelier-garage/page'));
const BulkSmsPage = lazy(() => import('../pages/secteurs/bulk-sms/page'));

import CommercePage from '../pages/secteurs/commerce/page';
import ImmobilierPage from '../pages/secteurs/immobilier/page';
import ProductionPage from '../pages/secteurs/production/page';
import EducationPage from '../pages/secteurs/education/page';
import SantePage from '../pages/secteurs/sante/page';
import TransportPage from '../pages/secteurs/transport/page';
import FinancePage from '../pages/secteurs/finance/page';
import AdministrationPage from '../pages/secteurs/administration/page';
import AutomationPage from '../pages/automation/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/solutions/erp',
    element: <ERPPage />,
  },
  {
    path: '/solutions/crm',
    element: <CRMPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/recrutement',
    element: <RecrutementPage />,
  },
  {
    path: '/ecosystem',
    element: <EcosystemPage />,
  },
  {
    path: '/secteurs/hotellerie',
    element: <HotelleriePage />,
  },
  {
    path: '/secteurs/beaute',
    element: <BeautePage />,
  },
  {
    path: '/secteurs/evenementiel',
    element: <EvenementielPage />,
  },
  {
    path: '/secteurs/restauration',
    element: <RestaurationPage />,
  },
  {
    path: '/secteurs/commerce',
    element: <CommercePage />,
  },
  {
    path: '/secteurs/immobilier',
    element: <ImmobilierPage />,
  },
  {
    path: '/secteurs/production',
    element: <ProductionPage />,
  },
  {
    path: '/secteurs/education',
    element: <EducationPage />,
  },
  {
    path: '/secteurs/sante',
    element: <SantePage />,
  },
  {
    path: '/secteurs/transport',
    element: <TransportPage />,
  },
  {
    path: '/secteurs/finance',
    element: <FinancePage />,
  },
  {
    path: '/secteurs/administration',
    element: <AdministrationPage />,
  },
  {
    path: '/secteurs/prestataire-service',
    element: <PrestataireServicePage />,
  },
  {
    path: '/secteurs/btp-construction',
    element: <BtpConstructionPage />,
  },
  {
    path: '/secteurs/rh-placement',
    element: <RhPlacementPage />,
  },
  {
    path: '/secteurs/cabinets-conseil',
    element: <CabinetsConseilPage />,
  },
  {
    path: '/secteurs/video-surveillance',
    element: <VideoSurveillancePage />,
  },
  {
    path: '/secteurs/atelier-garage',
    element: <AtelierGaragePage />,
  },
  {
    path: '/secteurs/bulk-sms',
    element: <BulkSmsPage />,
  },
  {
    path: '/automation',
    element: <AutomationPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;